export default "__VITE_ASSET__DaW76h5f__"